import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { PROVIDER } from 'src/environments/config';

@Component({
  selector: 'app-barcode-dialog',
  templateUrl: './barcode-dialog.component.html',
  styleUrls: ['./barcode-dialog.component.scss']
})
export class BarcodeDialogComponent  {
  barcodeUser!: string;

  obs: Subscription[] = []
  _user: any = null
  bpAgent: string | null = null;

  protected providerName = PROVIDER.providerName;

  constructor(
    private authService: AuthenticationService, 
    public modal: NgbActiveModal
  ){
    this.obs.push(
      this.authService.currentUser.subscribe(res => {
        this._user = res == null ? null : res.user
        if (this._user != null) {
          const fullName = this._user.bp_agent; 
          this.bpAgent = `${fullName || ''}`.trim();
          this.barcodeUser = String(this._user.id)
        }
      })
    )
  }

  ngOnInit(): void {
   
  }

  ngContentStart(): void {
    this.modal.dismiss();
    this.scrollToTop()
  }

  private scrollToTop(): void {
    window.scrollTo({ top: 0, behavior: 'auto' });
  }
}
